import React, { useState, useEffect } from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { RegisteredPayment, PaymentCategory } from "../../../../api";
import { useAuth } from "../../../../hooks";
import {
  initialValues,
  validationSchema,
} from "./NewRegisteredPaymentForm.form";
import { withEmptyOption } from "../../../../utils";
import "./NewRegisteredPaymentForm.scss";

const registeredPaymentController = new RegisteredPayment();
const paymentCategoryController = new PaymentCategory();

export function NewRegisteredPaymentForm(props) {
  const { studentActive, onReload } = props;
  const { accessToken } = useAuth();

  const [paymentCategoriesOptions, setPaymentCategoriesOptions] = useState([]);
  const [paymentConceptsOptions, setPaymentConceptsOptions] = useState([]);

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        formValue.studentId = studentActive.id;
        await registeredPaymentController.createRegisteredPayment(
          accessToken,
          formValue
        );
        formik.resetForm();
        onReload();
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    (async () => {
      try {
        setPaymentCategoriesOptions([]);
        const response =
          await paymentCategoryController.getPaymentCategoriesExcludingId(
            accessToken,
            studentActive.paymentCategoryId
          );
        const options = response.map((paymentCategory) => ({
          value: paymentCategory.id,
          text: paymentCategory.name,
        }));
        setPaymentCategoriesOptions(options);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [studentActive.paymentCategoryId, accessToken]);

  useEffect(() => {
    (async () => {
      try {
        setPaymentConceptsOptions([]);
        if (formik.values.paymentCategoryId) {
          const response =
            await paymentCategoryController.getPaymentConceptsByCategoryId(
              accessToken,
              formik.values.paymentCategoryId
            );
          const options = response.map((paymentConcept) => ({
            value: paymentConcept.id,
            text: paymentConcept.name,
          }));
          setPaymentConceptsOptions(options);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [formik.values.paymentCategoryId, accessToken]);

  return (
    <Form
      className="new-registered-payment__form"
      onSubmit={formik.handleSubmit}
    >
      <div className="custom-form-group">
        <div className="select-field">
          <Form.Select
            className="edunova-select"
            name="paymentCategoryId"
            label="Categoría de pago"
            placeholder="Selecciona una categoría de pago"
            clearable
            options={withEmptyOption(paymentCategoriesOptions, "Selecciona una categoría de pago")}
            onChange={(e, { value }) => {
              formik.setFieldValue("paymentCategoryId", value);
              formik.setFieldValue("paymentConceptId", null);
            }}
            value={formik.values.paymentCategoryId}
            error={formik.errors.paymentCategoryId}
          />
        </div>
        <div className="select-field">
          <Form.Select
            className="edunova-select"
            name="paymentConceptId"
            label="Concepto de pago"
            placeholder="Selecciona un concepto de pago"
            clearable
            options={withEmptyOption(paymentConceptsOptions, "Selecciona un concepto de pago")}
            onChange={(e, { value }) =>
              formik.setFieldValue("paymentConceptId", value)
            }
            value={formik.values.paymentConceptId}
            error={formik.errors.paymentConceptId}
          />
        </div>
        <div className="button-field">
          <div className="label-space"></div>
          <Form.Button
            type="submit"
            primary
            fluid
            loading={formik.isSubmitting}
          >
            Agregar concepto de pago
          </Form.Button>
        </div>
      </div>
    </Form>
  );
}
